// ============================================================
// SERVICE CONFIG — cambia USE_MOCKS per passare al backend reale
// ============================================================

export const USE_MOCKS = process.env.REACT_APP_USE_MOCKS !== 'false';

// Base URL del backend reale
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ?? 'http://localhost:8000/api';

// Chiave pubblicabile Stripe (safe da esporre lato client)
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ?? '';
